(function() {

    'use strict';

    angular.module('Services').service('CarrierCentreKgTableService', CarrierCentreKgTableService);

    CarrierCentreKgTableService.$inject = ['Carrier', 'TableLiteFactory'];

    function CarrierCentreKgTableService(Carrier, TableLiteFactory) {
        var tableStructure = {
            config: {
                noExtract: true
            },
            optionHeader: {
                title: "CENTRES PER KG'S",
                class: 'panel-title text-success p-t-3'
            },
            headers: [{
                label: 'COUNTRIES',
                viewName: 'country',
                filterName: 'country',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'ZONE NAME',
                viewName: 'zone_name',
                filterName: 'zone_name',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'ZONE FROM',
                viewName: 'zone_from',
                filterName: 'zone_from',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'ZONE TO',
                viewName: 'zone_to',
                filterName: 'zone_to',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'BASIC',
                viewName: 'basic',
                filterName: 'basic',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'MINIMUM',
                viewName: 'minimum',
                filterName: 'minimum',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'PER KG RATE',
                viewName: 'per_kg_rate',
                filterName: 'per_kg_rate',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }, {
                label: 'TRANSIT TIME',
                viewName: 'transit_time',
                filterName: 'transit_time',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                },
            }],
            data: []
        };
        const tableActions = new TableLiteFactory(tableStructure,
            {
                serviceCallback: Carrier.getServiceProfile,
                callbackFormat: ['success','error','filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters : {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            }
        );
        const sort = tableActions.sort;
        const evaluateFilter = Carrier.getCarriers;
        const sendRequest = tableActions.sendRequest;

        function buildTableData(data, pagination) {
            /*** START - Building of Data ***/
            tableActions.initializeTableData(data);
            angular.forEach(data.centres_kg, function(row, index) {
                
                //row.href = '/carriers/service-profile/view/' + row.id;

                tableStructure.data.push(row);
            });
            /*** END - Building of Data ***/
        }
        return tableStructure;
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/CarrierCentreKgTableService.js